<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{routeName}}</a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-if="!user">
            <router-link class='nav-link' to='login'>
              <i class="ti-user"></i>
              <p>
                Login
              </p>
            </router-link>
          </li>
          <drop-down v-if="user"
                class="nav-item"
                     :title="user.name"
                     title-classes="nav-link"
                     icon="ti-user">
            <router-link class='dropdown-item' to='editProfile'>Editar Perfil</router-link>
            <router-link class='dropdown-item' to='passwordChange'>Trocar Senha</router-link>
            <a class="dropdown-item" href="#" @click.stop.prevent='logout()'>Logout</a>
          </drop-down>
        </ul>
      </div>
    </div></nav>
</template>
<script>

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user']),
    routeName () {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    }
  },
  data () {
    return {
      activeNotifications: false
    }
  },
  methods: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown () {
      this.activeNotifications = false
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false)
    },
    logout () {
      this.$store.dispatch('logout')
      this.$router.push('busca')
    }
  }
}
</script>
<style>
</style>
